<template>
  <VaForm ref="form" @submit.prevent="submit">
    <h1 class="font-semibold text-4xl mb-4">欢迎登录</h1>
    <!-- <p class="text-base mb-4 leading-5">
      还没有账号?
      <RouterLink :to="{ name: 'signup' }" class="font-semibold text-primary">注册新账号</RouterLink>
    </p> -->
    <VaInput
      v-model="formData.email"
      :rules="[validators.required, validators.email]"
      class="mb-4"
      label="邮箱地址"
      type="email"
    />
    <VaValue v-slot="isPasswordVisible" :default-value="false">
      <VaInput
        v-model="formData.password"
        :rules="[validators.required]"
        :type="isPasswordVisible.value ? 'text' : 'password'"
        class="mb-4"
        label="登录密码"
        @clickAppendInner.stop="isPasswordVisible.value = !isPasswordVisible.value"
      >
        <template #appendInner>
          <VaIcon
            :name="isPasswordVisible.value ? 'mso-visibility_off' : 'mso-visibility'"
            class="cursor-pointer"
            color="secondary"
          />
        </template>
      </VaInput>
    </VaValue>

    <!-- <div class="auth-layout__options flex flex-col sm:flex-row items-start sm:items-center justify-between">
      <VaCheckbox v-model="formData.keepLoggedIn" class="mb-2 sm:mb-0" label="保持登录状态" />
      <RouterLink :to="{ name: 'recover-password' }" class="mt-2 sm:mt-0 sm:ml-1 font-semibold text-primary">
        忘记密码?
      </RouterLink>
    </div> -->

    <div class="flex justify-center mt-4">
      <VaButton class="w-full" @click="submit"> 登录</VaButton>
    </div>
    <div class="flex justify-center" style="padding-top: 30px">
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025388188号-1</a>
    </div>
  </VaForm>
</template>

<script lang="ts" setup>
import { reactive } from 'vue'
import { useForm } from 'vuestic-ui'
import { validators } from '../../services/utils'

const { validate } = useForm('form')
// const { push } = useRouter()
// const { init } = useToast()

const formData = reactive({
  email: '',
  password: '',
  keepLoggedIn: false,
})

const submit = () => {
  if (validate()) {
    // init({ message: "You've successfully logged in", color: 'success' })
    // push({ name: 'dashboard' })
  }
}
</script>
